import React, { createContext, useContext } from "react";

import Profile from "../components/reactflow/nodes/Profile";
import Institution from "../components/reactflow/nodes/Institution";
import Account from "../components/reactflow/nodes/Account";
import CustomEdge from "../components/reactflow/edges/CustomEdge";

const FlowElementsContext = createContext();

const AutoLayoutProvider = ({ children }) => {
  const nodeTypes = {
    profile: Profile,
    institution: Institution,
    account: Account,
  };

  const edgeTypes = {
    custom: CustomEdge,
  };

  return (
    <FlowElementsContext.Provider value={{ nodeTypes, edgeTypes }}>
      {children}
    </FlowElementsContext.Provider>
  );
};

export const useFlowElementsContext = () => useContext(FlowElementsContext);
export default AutoLayoutProvider;
